import { UserActHttp } from '../services/http/UserActHttp';
import { createImmutableDataFetchStore } from '../utilities/ImmutableDataFetchStore';

export const useUserActStore = createImmutableDataFetchStore((p: { organizationId: string }) =>
  new UserActHttp().getReceivers(p.organizationId).then((res) => res.data)
);
